/*  eslint no-param-reassign: ["error", { "props": false }]*/
import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import clone from 'clone';
import {
  Form,
  Grid,
} from 'semantic-ui-react';
import { required } from '@mhub/web-validations';
import AppForm from '../../components/AppForm';
import TextArea from '../../components/AppForm/TextArea';
import { namespaces, TRANSLATION_FILES } from '../../constants/translation';

class SMSTemplateForm extends Component {
  static propTypes = {
    onSubmit: PropTypes.func.isRequired,
    onChange: PropTypes.func,
    template: PropTypes.shape({
      name: PropTypes.string,
    }),
    t: PropTypes.func,
  }
  static contextTypes = {
    store: PropTypes.object,
  }
  static defaultValues = {
    id: '',
    name: '',
    template: '',
    lastTemplate: '',
  }
  constructor(props) {
    super(props);
    const template = Object.assign({}, SMSTemplateForm.defaultValues, props.template || {});
    this.state = {
      template,
      oriTemplate: clone(template),
      errMessages: [],
    };
    this.validation = {
      id: createRef(),
      name: createRef(),
      template: createRef(),
    };
  }
  componentWillReceiveProps(nextProps) {
    let template = Object.assign({}, SMSTemplateForm.defaultValues, this.state.template);
    let oriTemplate = this.state.oriTemplate;
    if (JSON.stringify(this.props.template) !== JSON.stringify(nextProps.template)) {
      template = Object.assign(template, nextProps.template);
      oriTemplate = clone(template);
    }
    this.setState({ template, oriTemplate });
  }
  submit(url, opts) {
    return this.form.submit(url, opts);
  }
  handleSubmit = (event) => {
    event.preventDefault();
    const { template } = this.state;
    AppForm.validate(this.validation, template)
      .then((validations) => {
        this.props.onSubmit(validations, template);
      });
  }
  handleCheckChanges() {
    if (this.props.onChange) {
      this.props.onChange(true);
    }
  }
  handleInputChange = (event, data) => {
    const { template } = this.state;
    template[data.name] = data.value;
    this.setState({ template }, () => {
      this.handleCheckChanges();
    });
  }
  render() {
    const { t } = this.props;
    const { template, oriTemplate } = this.state;
    return (
      <AppForm
        onSubmit={this.handleSubmit}
        error={this.state.errMessages.length > 0}
        ref={(ref) => { this.form = ref; }}
      >
        <Grid columns="equal" stackable doubling>
          <Grid.Row>
            <Grid.Column>
              <AppForm.Input
                placeholder="sms/<template_name>.tmpl"
                disabled={oriTemplate.id !== ''}
                label="ID"
                name="id"
                value={template.id}
                onChange={this.handleInputChange}
                ref={this.validation.id}
                validation={[required]}
              />
              <AppForm.Input
                disabled={oriTemplate.name && oriTemplate.name.toLowerCase().includes('default')}
                placeholder={t('Template Name', { ns: TRANSLATION_FILES.translation })}
                label={t('Name', { ns: TRANSLATION_FILES.translation })}
                name="name"
                value={template.name}
                onChange={this.handleInputChange}
                ref={this.validation.name}
                validation={[required]}
              />
              <TextArea
                disabled={oriTemplate.name && oriTemplate.name.toLowerCase().includes('default')}
                placeholder={t('Paste Go HTML template data here..', { ns: TRANSLATION_FILES.translation })}
                label={t('Template Data', { ns: TRANSLATION_FILES.translation })}
                name="template"
                value={template.template}
                onChange={this.handleInputChange}
                style={{ minHeight: 500 }}
                ref={this.validation.template}
                validation={[required]}
              />
              {oriTemplate.lastTemplate !== '' &&
                <Form.TextArea
                  label={t('Previous Template Data (read only)', { ns: TRANSLATION_FILES.translation })}
                  name="lastTemplate"
                  readOnly
                  style={{ minHeight: 250 }}
                  value={template.lastTemplate}
                />
              }
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </AppForm>
    );
  }
}

export default withTranslation(namespaces, { withRef: true })(SMSTemplateForm);



// WEBPACK FOOTER //
// ./src/containers/SMSTemplates/Form.jsx